import { useState, useRef } from "react";
import Chance from 'chance'
/*import * as Music from './src'*/

const chance = new Chance();

/*export const SOUNDS = {
  ALE1: Music.track1,
  ALE2: Music.track2,
  ZALUP: Music.track3,
  ACIDLOOP: Music.track4,
}*/

/*
export const GUITAR_SOUNDS = {
  Am: Music.Am,
  E: Music.E,
  Dm: Music.Dm,
  C: Music.C,

  AmC: Music.AmC,
  OneStringSolo: Music.oneStringSolo,
}
*/

const useSounds = () => {
  const [playList, setPlayList] = useState({});
  const [volume, setVolume] = useState(1);
  const audioElements = useRef({});

  const onPause = null

  const onPlay = (src, id, loop, ref) => {
    const audioId = id ? id : chance.guid()
    if(audioElements.current[audioId]) return
    const audioElement = document.createElement("audio");
    audioElement.id = audioId;
    audioElement.src = src;
    audioElement.loop = loop;
    audioElement.autoplay = true;
    audioElement.volume = volume;
    if (ref && ref.current) {
      ref.current.appendChild(audioElement)
    } else {
      document.body.appendChild(audioElement)
    }
    audioElements.current[audioId] = audioElement

    audioElement.addEventListener("ended", () => {
      if (ref && ref.current) {
        ref.current.removeChild(audioElement);
      } else {
        document.body.removeChild(audioElement);
      }
      delete audioElements.current[audioId];
    });
  }

  const onStopAll = () => {
    for (const audioId in audioElements.current) {
      const audioElement = audioElements.current[audioId];
      if(audioElement) {
        audioElement.pause();
        if(audioElement.parentElement) {
          audioElement.parentElement.removeChild(audioElement)
        }
        delete audioElements.current[audioId]
      }
    }
  }

  const setVolumeForAll = (newVolume) => {
    setVolume(newVolume);
    for (const audioId in audioElements.current) {
      const audioElement = audioElements.current[audioId];
      if (audioElement) {
        audioElement.volume = newVolume;
      }
    }
  }

  const onHardStopAll = () => {
    const audioElements = document.querySelectorAll("body audio");
    audioElements.forEach((audioElement) => {
      if (audioElement && audioElement.parentElement) {
        audioElement.parentElement.removeChild(audioElement);
      }
    });
  }


  return {
    playList,
    onPlay,
    onPause,
    onStopAll,
    onHardStopAll,
    setVolume: setVolumeForAll,
    currentVolume: volume,
    setPlayList,
  };
};

export default useSounds;
